module.exports = __webpack_public_path__ + "03f3bc4f499b6dfd75ff0e83f1fcdab4.svg";